/* PRP Pure home: the process tube follows scroll (draw → spin → treat). Authored SVG is the separated end state,
   so no-JS and reduced-motion visitors see the finished picture. */
(function () {
  var sec = document.querySelector('.process'); if (!sec) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) { sec.querySelectorAll('.step').forEach(function (s) { s.classList.add('on'); }); return; }
  var svg = sec.querySelector('.tube-svg'), q = function (c) { return sec.querySelector('.tube-' + c); };
  var mix = q('mix'), red = q('red'), buffy = q('buffy'), plasma = q('plasma'), shine = q('shine'), steps = sec.querySelectorAll('.step');
  var k = function (p, a, b) { return Math.min(1, Math.max(0, (p - a) / (b - a))); };
  var ease = function (t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  function draw(p) {
    var s = ease(k(p, .28, .62)), t = ease(k(p, .7, .95));
    mix.setAttribute('opacity', (1 - s).toFixed(3));
    var ry = 78 + 207 * s;
    red.setAttribute('y', ry.toFixed(1)); red.setAttribute('height', (470 - ry).toFixed(1)); red.setAttribute('opacity', Math.min(1, s * 1.4).toFixed(3));
    buffy.setAttribute('y', (ry - 8).toFixed(1)); buffy.setAttribute('opacity', s.toFixed(3));
    var py = 78 + 96 * t;
    plasma.setAttribute('y', py.toFixed(1)); plasma.setAttribute('height', Math.max(0, ry - 8 - py).toFixed(1)); plasma.setAttribute('opacity', s.toFixed(3));
    shine.setAttribute('opacity', (Math.sin(s * Math.PI) * .5).toFixed(3));
    var wob = s > 0 && s < 1 ? Math.sin(s * Math.PI * 10) * (1 - s) * 5 : 0;
    svg.style.transform = 'rotate(' + wob.toFixed(2) + 'deg)';
    var idx = p < .3 ? 0 : p < .68 ? 1 : 2;
    steps.forEach(function (st, i) { st.classList.toggle('on', i === idx); });
  }
  sec.addEventListener('scrub', function (e) { draw(e.detail); });
  draw(parseFloat(getComputedStyle(sec).getPropertyValue('--p')) || 0);
})();
